import React from 'react';

const Facebook = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M4.00096 4.00063H20V19.9028H4.00096V4.00063Z" fill="white" />
    <path fillRule="evenodd" clipRule="evenodd" d="M20 12C20 7.58171 16.4183 4 12 4C7.58171 4 4 7.58171 4 12C4 15.993 6.92548 19.3026 10.75 19.9028V14.3125H8.71874V12H10.75V10.2375C10.75 8.23249 11.9443 7.125 13.7717 7.125C14.647 7.125 15.5625 7.28124 15.5625 7.28124V9.24999H14.5537C13.5599 9.24999 13.25 9.86666 13.25 10.4993V12H15.4687L15.114 14.3125H13.25V19.9028C17.0745 19.3026 20 15.993 20 12Z" fill="#1877F2" />
    <path fillRule="evenodd" clipRule="evenodd" d="M15.114 14.3125L15.4687 12H13.25V10.4993C13.25 9.86666 13.5599 9.24999 14.5537 9.24999H15.5625V7.28124C15.5625 7.28124 14.647 7.125 13.7717 7.125C11.9443 7.125 10.75 8.23249 10.75 10.2375V12H8.71874V14.3125H10.75V19.9028C11.1573 19.9667 11.5747 20 12 20C12.4252 20 12.8427 19.9667 13.25 19.9028V14.3125H15.114Z" fill="white" />
  </svg>
);

export default React.memo(Facebook);
